// extracted by mini-css-extract-plugin
export default {"page":"StatusPageView_page__iSvwj","content":"StatusPageView_content__uhT3W","noBanner":"StatusPageView_noBanner__54MWI","list":"StatusPageView_list__Y5lTX"};